<template>
  <div id="modal" class="modal estimate_modal" v-show="modalShown">
    <div class="modal-main wrapper" id="estimate_main">
      <div class="cross_btn2" @click="onCancel()">
        <span class="css-cancel"></span>
      </div>
      <div class="estimate_area" v-if="isProductData">
        <div class="estimate_infomation">
          <section class="estimation">
            <h3 class="title">見積り明細</h3>
            <dd-price
              :itemName="fileName"
              :priceData="priceData"
              :targetPlan="targetPlan"
              :dcProductCount="dcProductCount"
              :isCalcDelivery="isCalcDelivery"
            />
          </section>
          <div class="separate_line"></div>
          <section id="color">
            <h3 class="title">カラー</h3>
            <ul class="color_list">
              <li v-if="colorDoor">
                <dd-color
                  :title="titleDoor"
                  :color="colorDoor"
                />
              </li>
              <li v-if="colorCabine">
                <dd-color
                  :title="titleCabine"
                  :color="colorCabine"
                />
              </li>
              <li v-if="colorCounter">
                <dd-color
                  :title="titleCounter"
                  :color="colorCounter"
                />
              </li>
            </ul>
          </section>
          <div class="separate_line"></div>
        </div>
      </div>
      <section v-if="isDrawing" id="noinfo_sheet" class="print_view page-always" >
        <h3 class="title">商品図面</h3>
        <dd-sheet
          ref="sheetModalRef"
          :spaceJoincd="spaceJoincd"
          :isPreview=false
          :svgWidth="svgWidth"
          :svgHeight="svgHeight"
          @showModal="delayShowModal"
        />
        <div class="sheet_footer"></div>
      </section>
      <!-- <section id="carry_caution">
        <div>
          <h3>商品搬入時の注意点</h3>
          <p>
            搬入時に、家具が入らなくて困ることがあります。室内開口部やマンションのエレベータ、階段幅など狭い箇所を事前に採寸し、梱包サイズが搬入できるかご確認ください。<br>
            トイレや収納スペースなどの狭い場所では、スペースぴったりのサイズで作成すると、ドア枠や窓枠などに引っかかり、搬入できない恐れがあります。<br>
            狭い場所では、商品本体のサイズを小さめに作成し、フィラーを活用することで搬入が可能となります。
          </p>
          <div>
            <img :src="getImage('common/noimage.png')" style="width:20rem;">
          </div>
        </div>
      </section> -->
      <section class="consent-area" v-if="isConsentImg">
        <div class="consent_title">設置場所確認リスト</div>
        <div>
          <div class="consent-img-area">
            <img :src="getImage(consentImg)" />
          </div>
          <div class="check_box">
            <input type="checkbox" id="consentRule" v-model="isConsent"/>
            <label for="consentRule">全ての項目を確認しました。</label>
          </div>
        </div>
      </section>
      <div class="cart-area">
        <div class="success-btn-area">
          <!--
          <div class="main_btn act_sub_btn icon_btn" @click="preview()" v-if="isDrawing" v-on:mouseover="isOnPreview(true)" v-on:mouseleave="isOnPreview(false)">
            <img :src="imgPreview" class="icon">
            <div>プレビュー</div>
          </div>
          <div class="main_btn act_sub_btn icon_btn" @click="print()" v-on:mouseover="isOnPrint(true)" v-on:mouseleave="isOnPrint(false)">
            <img :src="imgPrint" class="icon">
            <div>印刷</div>
          </div>
          -->
          <div :class="{main_btn: true, sel_main_btn: true, icon_btn: true, center_fix_btn: true, disabled: isConsentDisable}" @click="onOrder()" v-if="dispOrderButton" v-on:mouseover="isOnCart(true)" v-on:mouseleave="isOnCart(false)">
            <!--
            <img :src="imgCart" class="icon">
            -->
            <a>{{orderTitle}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as App from '../../../../../utils/App'
import * as AppEc from '../../../../utils/AppEc'
import * as Check from '../../../../../utils/Check'

import PriceList from '../../../payment/PriceList'
import Color from '../color/DcColor'
import Sheet from './DcEstimateSheet'

export default {
  name: 'estimateModal',
  components: {
    'dd-color': Color,
    'dd-price': PriceList,
    'dd-sheet': Sheet
  },
  props: {
    /** OK押下時コールバック */
    onOk: {
      type: Function,
      default: function () {}
    },
    onSearch: {
      type: Function,
      default: function () {}
    },
    /** コールバックに渡す引数 */
    callbackParams: {
      type: Object,
      default: function () { return {} }
    },
    showSuccess: {
      type: Function,
      default: function () {}
    },
    dcFdId: Number,
    fileName: {
      type: String,
      default: ''
    },
    titleDoor: {
      type: String
    },
    colorDoor: {
      type: Object
    },
    titleCabine: {
      type: String
    },
    colorCabine: {
      type: Object
    },
    titleCounter: {
      type: String
    },
    colorCounter: {
      type: Object
    },
    priceData: {
      type: Object
    },
    targetPlan: {
      type: Object,
      default: undefined
    },
    spaceJoincd: String,
    dispOrderButton: {
      type: Boolean,
      default: true
    },
    dcProductCount: Number,
    isCalcDelivery: Boolean,
    resrchFlag: {
      type: Boolean,
      default: false
    },
    isDrawing: Boolean,
    corpData: {
      type: Object,
      default: undefined
    },
    isProductData: {
      type: Boolean,
      default: true
    },
    consentImg: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      svgWidth: '100%',
      svgHeight: '100%',
      imgPreview: this.getImage('common/preview_black.svg'),
      imgPrint: this.getImage('common/print_black.svg'),
      imgCart: this.getImage('common/cart_white.svg'),
      isConsent: false
    }
  },
  watch: {
  },
  computed: {
    orderTitle: function () {
      if (this.resrchFlag) {
        return '注文する'
      } else {
        return 'カートに追加'
      }
    },
    mailTo: function () {
      return '「@domans.co.jp」、「@candeal.co.jp」'
    },
    isConsentImg: function () {
      if (!this.consentImg) {
        return false
      }
      return true
    },
    isConsentDisable: function () {
      if (!this.consentImg) return false
      return !this.isConsent
    }
  },
  methods: {
    showModal: function () {
    },
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    },
    delayShowModal: function () {
      this.showSuccess(this.callbackParams)
      // 図面が完成してから表示
      this.modalShown = true
      this.$nextTick(function () {
        if (!Check.isBrawserIE()) return
        let modalWidth = document.getElementById('estimate_main').clientWidth
        let modalHeight = document.getElementById('estimate_main').clientHeight
        // 親領域のpadding、右のスクロールバーを引く
        this.svgWidth = (modalWidth - 20 - 20) + 'px'
        this.svgHeight = modalHeight * 0.6 + 'px'
      })
    },
    onCancel: function () {
      this.modalShown = false
      document.body.style.overflow = 'scroll'
    },
    onOrder: function () {
      if (!this.modalShown) return
      this.onOk(this.callbackParams)
      this.modalShown = false
    },
    handleScroll: function (event) {
      event.preventDefault()
    },
    preview: function () {
      let modalData = {
        svgWidth: '90%',
        spaceJoincd: this.spaceJoincd,
        isShowInfo: true
      }
      AppEc.showPreview(modalData)
    },
    print: function () {
      window.print()
    },
    isOnPreview: function (on) {
      if (on) {
        this.imgPreview = this.getImage('common/preview_white.svg')
      } else {
        this.imgPreview = this.getImage('common/preview_black.svg')
      }
    },
    isOnPrint: function (on) {
      if (on) {
        this.imgPrint = this.getImage('common/print_white.svg')
      } else {
        this.imgPrint = this.getImage('common/print_black.svg')
      }
    },
    isOnCart: function (on) {
      if (on) {
        this.imgCart = this.getImage('common/cart_red.svg')
      } else {
        this.imgCart = this.getImage('common/cart_white.svg')
      }
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    onOutRange: function () {
      this.modalShown = false
    }
  }, // end method
  mounted: function () {
  },
  created: function () {
    if (!this.isDrawing) this.delayShowModal()
  }
}
</script>
<style src="../../../../css/dc-order.scss" lang="scss" scoped></style>
<style src="../../../../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/top/input/estimate/DcEstimateModal.vue